export default __webpack_public_path__ + "static/media/outlogic-logo_white.b7c39c23.png";